import { SmoMoon } from '../Models/Smo/SmoMoon';
import { UserRun } from '../Models/User/UserRun';
import { Optional } from './Types';

function remainingMoons(run: UserRun): SmoMoon[] {
  const lastCollectedIndex: Optional<number> = lastCollectedMoonIndex(run);
  if (lastCollectedIndex === undefined) {
    return run.moonList.moons;
  }
  return run.moonList.moons
    .slice(lastCollectedIndex + 1)
    .filter((remaining) => !run.collectedMoons.some((moon) => moon.id === remaining.id));
}

function nextMoon(run: UserRun): Optional<SmoMoon> {
  const remaining: SmoMoon[] = remainingMoons(run);
  if (remaining.length > 0) {
    return remaining[0];
  }
  return undefined;
}

function lastCollectedMoon(run: UserRun): Optional<SmoMoon> {
  if (!hasCollectedMoons(run)) {
    return undefined;
  }
  return [...run.collectedMoons]
    .reverse()
    .find((collectedMoon) => run.moonList.moons.some((moon) => collectedMoon.id === moon.id));
}

function lastCollectedMoonIndex(run: UserRun): Optional<number> {
  const lastMoon: Optional<SmoMoon> = lastCollectedMoon(run);
  if (lastMoon) {
    return run.moonList.moons.findIndex((moon) => moon.id === lastMoon.id);
  }
  return undefined;
}

function hasCollectedMoons(run: UserRun): boolean {
  return run.collectedMoons.length > 0;
}

export default {
  remainingMoons,
  nextMoon
};
